import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export const ModalConfirmDeactivation = ({
  open,
  setOpen,
  onConfirm,
  title = 'Confirmar Desactivación',
  description = '¿Está seguro de desactivar este registro? Esta acción no eliminará los datos permanentemente.',
}: Props) => {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: { borderRadius: 3, minWidth: 420 },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ m: 1, p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              minWidth: 48,
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: '#FFE2E3',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DeleteOutlineOutlinedIcon color="error" />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ px: 3, py: 3, borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0' }}
      >
        <Box
          sx={{
            backgroundColor: '#FFF5F5',
            borderRadius: 2,
            p: 2,
            display: 'flex',
            gap: 1.5,
            alignItems: 'flex-start',
            border: '1px solid #FFE2E3',
          }}
        >
          <WarningAmberOutlinedIcon sx={{ color: '#d32f2f', fontSize: 22, flexShrink: 0 }} />
          <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 500, lineHeight: 1.5 }}>
            {description}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 2, pb: 2 }}>
        <Button
          onClick={handleClose}
          color="inherit"
          variant="outlined"
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3 }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          autoFocus
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3, boxShadow: 'none' }}
        >
          Desactivar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
